export const route = {
  confirmedPayment: '/confirmed-payment',
  confirmedPaymentTablet: '/confirmed-payment-tablet',
  statusPaymentNotify: '/status-payment-notify',
  statusPaymentInAdvanceNotify: '/status-payment-in-advance-notify',
}

export const path = {
  landingPage: '/',
  introduction: '/introduction',
  home: '/home',
  homeTablet: '/home-tablet',
  yourCart: '/your-cart',
  indexMenu: '/menu',
  indexMenuTablet: '/menu-tablet',
  callStaff: '/call-staff',
  callStaffTablet: '/call-staff-tablet',
  ordering: '/ordering',
  orderingFoodCourt: '/ordering-food-court',
  orderHistory: '/order-history',
  orderHistoryFoodCourt: '/order-history-food-court',
  payment: '/payment',
  confirmedPayment: `${route.confirmedPayment}/:keyword`,
  confirmedPaymentTablet: `${route.confirmedPaymentTablet}/:keyword`,
  searchFood: '/search-food',
  rescanQR: '/rescan-qr',
  choosePaymentMethod: '/choose-payment-method',
  statusPaymentNotify: `${route.statusPaymentNotify}/:status`, // status có thể là: success, failed,... Nói chung là màn này dùng chung
  statusPaymentInAdvanceNotify: `${route.statusPaymentInAdvanceNotify}/:status`, // status có thể là: success, failed,... Nói chung là màn này dùng chung
  tokenRedirect: '/:restaurantSlug/:tableUid',
  restaurantSlug: '/:restaurantSlug',
  foodCourtRedirect: '/food_courts/:food_court_slug/tables/:table_uuid', // đường dẫn phục vụ cho việc quét qr sau đó redirect
  shortLinkRedirect: '/:food_court_slug/:short_link_id/s',
  foodCourt: '/food-court',
  orderPlacedSouvenir: '/order-placed-souvenir',
  reviewOrder: '/review-order',
  notFound: '*',
}
